import { createSelector } from 'reselect'

import { getFilteredCockpitPartnerData } from '../../lib'

import { selectCockpitCompletenessData } from './selectCockpitCompletenessData'
import { selectCockpitFilter } from './selectCockpitFilter'
import { selectCockpitGeoMappingItems } from './selectCockpitGeoMappingItems'
import { selectCockpitManagerUsersForFiltering } from './selectCockpitManagerUsersForFiltering'
import { selectCockpitOffering } from './selectCockpitOffering'
import { selectCockpitPartnerClassFlags } from './selectCockpitPartnerClassFlags'
import { selectCockpitPartnerData } from './selectCockpitPartnerData'
import { selectCockpitPbmUsersForFiltering } from './selectCockpitPbmUsersForFiltering'
import { selectCockpitRtm } from './selectCockpitRtm'

export const selectFilteredCockpitPartnerData = createSelector(
  [
    selectCockpitPartnerData,
    selectCockpitRtm,
    selectCockpitOffering,
    selectCockpitCompletenessData,
    selectCockpitFilter,
    selectCockpitPbmUsersForFiltering,
    selectCockpitManagerUsersForFiltering,
    selectCockpitGeoMappingItems,
    selectCockpitPartnerClassFlags,
  ],
  (
    partnerData,
    selectedRtm,
    selectedOffering,
    completenessData,
    filter,
    pbmUsers,
    managerUsers,
    geoMappingItems,
    partnerClassFlags
  ) =>
    getFilteredCockpitPartnerData({
      partnerData,
      selectedRtm,
      selectedOffering,
      completenessData,
      filter,
      pbmUsers,
      managerUsers,
      geoMappingItems,
      partnerClassFlags,
    })
)
